<script lang="ts">
    import {guiCreatorDataStore} from '../../stores/guiCreatorData';
    import {UISlider} from './slider';
    import ConfigInput from "../utils/ConfigTextInput.svelte";
    import {UIElement} from '../element';
    import {OriginCoords} from '../../types';
    import ConfigCheckbox from '../utils/ConfigCheckbox.svelte';
    import {InputTypes} from '../../utils/helpers';

    export let uiElement: UISlider;
    export let origin: OriginCoords;

    let nameValue = uiElement.name;
    let xValue = uiElement.x.toString();
    let yValue = uiElement.y.toString();
    let lengthValue = uiElement.length.toString();
    let sliderSizeValue = uiElement.sliderSize.toString();
    let sliderPositionValue = uiElement.sliderPosition.toString();
    let verticalValue = uiElement.vertical;
    let groupValue = uiElement.group;
    let zValue = uiElement.z;
    let sliderHitBoxOffsetValue = uiElement.sliderHitBoxOffset.toString();
    let sliderShowHitBoxValue = !!uiElement.sliderShowHitBox;

    function onValueChange(attributeName: keyof UISlider | keyof UIElement, inputType: string = InputTypes.INT) {
        return (value) => {

            let parsedValue = value.detail;
            switch (inputType) {
                case InputTypes.INT:
                    parsedValue = parseInt(value.detail);
                    break;
                case InputTypes.FLOAT:
                    parsedValue = parseFloat(value.detail);
                    break;
            }
            if (attributeName === 'sliderPosition') {
                if (parsedValue < 0) {
                    parsedValue = 0;
                }
                if (parsedValue > 1) {
                    parsedValue = 1;
                }
            }
            uiElement[attributeName] = parsedValue;
            guiCreatorDataStore.update(uiElement);
        }
    }


</script>

<div>

    <div class="flex flex-row bg-center pt-1">
        <p class="text-lg">Infos: Slider</p>
    </div>

    <ConfigInput value="{nameValue}" on:configValueChanged={onValueChange('name', InputTypes.STRING)}
                 title="Name"></ConfigInput>
    <ConfigInput value="{groupValue || ''}" on:configValueChanged={onValueChange('group', InputTypes.STRING)}
                 title="Group"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Position</p>
    </div>
    <ConfigInput value="{xValue}" on:configValueChanged={onValueChange('x', InputTypes.INT)}
                 title="X"></ConfigInput>
    <ConfigInput value="{yValue}" on:configValueChanged={onValueChange('y', InputTypes.INT)}
                 title="Y"></ConfigInput>
    <ConfigInput value="{zValue}" on:configValueChanged={onValueChange('z', InputTypes.INT)}
                 title="Z"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Slider Configs</p>
    </div>
    <ConfigInput value="{lengthValue}" on:configValueChanged={onValueChange('length', InputTypes.INT)}
                 title="Length"></ConfigInput>
    <ConfigCheckbox value="{verticalValue}" on:configValueChanged={onValueChange('vertical', InputTypes.BOOLEAN)}
                    title="Vertical"></ConfigCheckbox>
    <ConfigInput value="{sliderSizeValue}" on:configValueChanged={onValueChange('sliderSize', InputTypes.INT)}
                 title="Slider size"></ConfigInput>
    <ConfigInput value="{sliderPositionValue}" on:configValueChanged={onValueChange('sliderPosition', InputTypes.FLOAT)}
                 title="Slider postion"></ConfigInput>
    <ConfigInput value="{sliderHitBoxOffsetValue}"
                 on:configValueChanged={onValueChange('sliderHitBoxOffset', InputTypes.INT)}
                 title="Hitbox offset"></ConfigInput>
    <ConfigCheckbox value="{sliderShowHitBoxValue}"
                    on:configValueChanged={onValueChange('sliderShowHitBox', InputTypes.BOOLEAN)}
                    title="Show hitbox"></ConfigCheckbox>

</div>

<style>

    .text-input-combination {
        border-style: dashed;

        display: grid;
        grid-template-columns: 60px 80%;
    }
</style>
